import React from 'react';

import Button from "@tine/tiff/dist/components/button";
import Icon from '@tine/tiff/dist/components/icon';

export const CtaButton = ({description = '', buttonText = '', destination = '', btnClass = '', gaTag = '', showArrowIcon='false', target='_self'}) => {
	const addGaTag = () => {
		if (gaTag && gaTag !== '') {
			window.dataLayer.push({
				'event': gaTag
			});
		}
	};

	let arrowicon = <Icon size="small" icon="arrow_right" />;
	return (
		<Button action={btnClass} href={destination} target={target} aria-describedby={description} className="cta-btn" onClick={addGaTag}>
			<span className="a-btn-text">{buttonText}</span>
			{showArrowIcon === 'true' ? arrowicon : null}
		</Button>
	);
};

export const Component = CtaButton;
export default {Component};
